'use strict';

var helpers = require('./utils/index');
var requestInfo = require('./methodsConfig/requestsInfo');
var request = require('./request/index');
var AppConfig = require('./common/config');

var DsSdk = function DsSdk() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$lang = _ref.lang,
        lang = _ref$lang === undefined ? AppConfig.defaultLanguage : _ref$lang,
        _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === undefined ? AppConfig.host : _ref$baseUrl,
        _ref$auth = _ref.auth,
        auth = _ref$auth === undefined ? {} : _ref$auth,
        _ref$headers = _ref.headers,
        headers = _ref$headers === undefined ? {} : _ref$headers;

    this.lang = lang;
    this.baseUrl = baseUrl;
    this.requestAuth = auth;
    this.headers = headers;

    return this;
};

requestInfo.forEach(function (methodInfo) {
    var methodConfig = helpers.configBuilder(methodInfo);
    DsSdk.prototype[methodConfig.builderMethodName] = function () {
        return new request.builder(methodConfig, { lang: this.lang }, this.baseUrl, this.requestAuth, this.headers);
    };
});

module.exports = DsSdk;